const ZIP_REGEX = /^[0-9]{5}$/;

export function ZipCodeValidator() {
  return {
    require: 'ngModel',
    link,
  };

  function link(scope, element, attrs, ctrl) {
    ctrl.$validators.zipCode = function($modelValue, $viewValue) {
      const value = $modelValue || $viewValue;
      return !value || ZIP_REGEX.test(value);
    };
  }
}
